module.exports = __webpack_public_path__ + "img/130-50M-CMS 16_9.09dfad90.png";